import { Link } from 'react-router';

export function NotFoundPage(): React.JSX.Element {
  return (
    <section className="dc-card" data-testid="page-not-found">
      <h1>Not found</h1>
      <p className="dc-dim">
        No such page. <Link to="/">Back to the inspector</Link>.
      </p>
    </section>
  );
}
